
// SlksDateFormat,
import { useFormattedEsDate } from "@slks/core";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    name: "EsDate",
    props: {
        startDate: String,
        endDate: String,
        format: {
            type: String as PropType<"auto" | "year">,
            default: "auto",
        },
        period: {
            type: Boolean,
            default: false,
        },
        autoPeriod: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const { formattedEsDate } = useFormattedEsDate(
            props.startDate,
            props.endDate,
            props.format,
            props.period,
            props.autoPeriod
        );

        return { formattedEsDate };
    },
});
